import { SparklesIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import { ASK_TROVIX_PERMISSIONS } from "./permissions";

import type { FeatureMetadata } from "@/features/feature.types";
import { buildCrudPermissions } from "@/features/shared/featureFactories";

export const AskTrovixFeature = {
  id: "ask-trovix",
  moduleName: "ai",
  navigation: {
    label: "Ask Trovix",
    path: "/ask-trovix",
    icon: SparklesIcon,
    order: 1,
  },
  // One key opens everything: the menu entry, the route, the command palette and every request. No guardian
  // navigation: Ask Trovix serves staff contexts only, and the server refuses any other.
  permissions: buildCrudPermissions("AI", "AskTrovix", {
    view: ASK_TROVIX_PERMISSIONS.use,
    create: ASK_TROVIX_PERMISSIONS.use,
    edit: ASK_TROVIX_PERMISSIONS.use,
    delete: ASK_TROVIX_PERMISSIONS.use,
  }),
  route: {
    path: "/ask-trovix/*",
    element: lazy(() => import("./pages/AskTrovix")),
  },
  readiness: "live",
} as const satisfies FeatureMetadata;
